export class BooleanUDF{
  public thingTypeFieldId: number;

  public time: number;

  public value: boolean;

  constructor(value: boolean) {
    this.value = value;
  }
}



// WEBPACK FOOTER //
// ./src/models/UDFs/BooleanUDF.ts